export default {
  'Watermark': '水印',
  'Add Watermark Selection': '添加水印選區',
}